import React from 'react';
import PropTypes from 'prop-types';
import { useIntl, defineMessages } from 'react-intl';

import CCRadioButton from 'components/shared/DesignSystem/SlabTransferPortal/CCRadioButton';
import { ASC, DESC } from 'constants/sortDirections';
import RadioWrap from './RadioWrap';
import GroupTitle from './GroupTitle';

const messages = defineMessages({
  title: {
    id: 'AssetFeed.ViewMenu.SortOrderToggle.title',
    defaultMessage: 'Order',
    description: 'View menu asset order title',
  },
  labelNewest: {
    id: 'AssetFeed.ViewMenu.SortOrderToggle.labelNewest',
    defaultMessage: 'Newest First',
    description: 'Label for toggling asset order to newest first',
  },
  labelOldest: {
    id: 'AssetFeed.ViewMenu.SortOrderToggle.labelOldest',
    defaultMessage: 'Oldest First',
    description: 'Label for toggling asset order to oldest first',
  },
});

const SortOrderToggle = ({ setSortOrder, sortOrder }) => {
  const { formatMessage } = useIntl();

  return (
    <div>
      <GroupTitle>{formatMessage(messages.title)}</GroupTitle>
      <RadioWrap>
        <CCRadioButton
          id={`asset-order-selector-${DESC}`}
          label={formatMessage(messages.labelNewest)}
          value={DESC}
          layout="inline"
          name="asset-order-selector"
          onChange={(checked) => {
            if (checked) {
              setSortOrder(DESC);
            }
          }}
          checked={sortOrder === DESC}
          data-testid="view_menu__order-newest"
        />
        <CCRadioButton
          id={`asset-order-selector-${ASC}`}
          label={formatMessage(messages.labelOldest)}
          value={ASC}
          layout="inline"
          name="asset-order-selector"
          onChange={(checked) => {
            if (checked) {
              setSortOrder(ASC);
            }
          }}
          checked={sortOrder === ASC}
          data-testid="view_menu__order-oldest"
        />
      </RadioWrap>
    </div>
  );
};

SortOrderToggle.propTypes = {
  setSortOrder: PropTypes.func,
  sortOrder: PropTypes.string,
};

export default SortOrderToggle;
